<template>
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">
        <div class="custom-control custom-switch ml-4 cursor" @click="alterado()">
          <input type="checkbox" class="custom-control-input" v-model="valor">
          <label
            class="custom-control-label"
            for="customSwitch1"
            style="padding-top: 4px"
          >{{ label }}</label>
        </div>
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    valor: {
      type: Boolean
    }
  },
  methods: {
    alterado() {
      this.$emit("alterado");
    }
  }
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
</style>